<app-document-viewer-page label="Parte de viajero" url="https://pdfobject.com/pdf/sample.pdf">
</app-document-viewer-page>

